import { FC, Fragment, useCallback, useState } from 'react';
import { Button, Link, Text } from '@servicetitan/anvil2';

import { MessageCard } from '../../message-card/message-card';
import { MultilineText } from '../../multiline-text/multiline-text';
import { formatDate } from '../../../utils/format-date';
import { EstimateItemModel } from '../../../models/estimate.model';
import { formatCurrency } from '../../../utils/format-currency';
import { EstimateTasks } from './estimate-tasks';

interface EstimateDetailProps {
    showCreateButton?: boolean;
    data: EstimateItemModel;
}

export const EstimateDetail: FC<EstimateDetailProps> = ({ data, showCreateButton = false }) => {
    const [showMore, setShowMore] = useState<boolean | undefined>(undefined);

    const handleLineCalculated = useCallback((isTruncated: boolean) => {
        if (isTruncated) {
            setShowMore(false);
        } else {
            setShowMore(undefined);
        }
    }, []);

    const toggleShowAll = () => {
        setShowMore(!showMore);
    };

    const handleCreateEstimateClick = () => {
        window.location.href = `/close`;
    };

    return (
        <Fragment>
            <MessageCard className="m-b-2" flexDirection="column">
                <Text variant="headline" el="h3" size="small">
                    Estimate ID #{data.estimate_id} - "{data.estimate_name}"
                </Text>

                <div className="m-b-1">
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Created by
                    </Text>
                    <Text className="m-b-1" size="small">
                        {data.estimate_created_by}
                    </Text>
                </div>

                <div className="m-b-1">
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Created On
                    </Text>
                    <Text className="m-b-1" size="small">
                        {formatDate(new Date(data.estimate_created_date))}
                    </Text>
                </div>

                <div className="m-b-1">
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Estimate Total
                    </Text>
                    <Text className="m-b-1" size="small">
                        {formatCurrency(data.estimate_total)}
                    </Text>
                </div>

                <div>
                    <Text variant="eyebrow" className="m-b-half" size="small">
                        Estimate Summary
                    </Text>
                    <MultilineText
                        onLinesCalculated={handleLineCalculated}
                        maxLines={showMore ? undefined : 3}
                    >
                        {data.estimate_summary}
                    </MultilineText>
                </div>

                {showMore !== undefined && (
                    <Link quiet appearance="primary" onClick={toggleShowAll}>
                        {showMore ? 'Show Less' : 'Show More'}
                    </Link>
                )}
            </MessageCard>

            <EstimateTasks data={data} />

            {/* TODO: remove */}
            {showCreateButton && (
                <Button appearance="secondary" onClick={handleCreateEstimateClick}>
                    Looks good
                </Button>
            )}
        </Fragment>
    );
};
